(() => {
  const form = document.querySelector('form[data-recell-cart-sync]');
  if (!form) return;
  const root = window.Shopify?.routes?.root || '/';
  const inputs = () => [...form.querySelectorAll('.cart__product-qty')];
  const dirty = () => inputs().some(input => input.value !== input.defaultValue) ||
    [...form.querySelectorAll('textarea')].some(input => input.value !== input.defaultValue);
  const signature = (items, total) => JSON.stringify({
    items: items.map(item => [String(item.key).split(':')[0], Number(item.quantity)]).sort((a, b) => a[0].localeCompare(b[0])),
    total: Number(total)
  });
  const initial = signature([...form.querySelectorAll('[data-recell-cart-key]')].map(row => ({
    key: row.dataset.recellCartKey,
    quantity: row.dataset.recellCartQuantity,
    final_line_price: row.dataset.recellCartPrice
  })), form.dataset.recellCartTotal);
  let pending = false;
  let leaving = false;
  let timer;
  async function check() {
    if (pending || leaving || document.hidden || dirty()) return;
    pending = true;
    try {
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (!leaving && !dirty() && signature(cart.items, cart.total_price) !== initial) {
        leaving = true;
        window.location.reload();
      }
    } catch (_) {
    } finally {
      pending = false;
    }
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, 350);
  }
  form.addEventListener('submit', () => {
    leaving = true;
    inputs().forEach(input => {
      if (input.value === input.defaultValue) input.disabled = true;
    });
  });
  form.addEventListener('click', event => {
    if (event.target.closest('a.remove-red')) leaving = true;
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) leaving = false;
    schedule();
  });
  window.addEventListener('focus', schedule);
  document.addEventListener('visibilitychange', schedule);
  ['cart:updated', 'cart:change', 'cart:refresh'].forEach(name => document.addEventListener(name, schedule));
  if ('PerformanceObserver' in window) {
    const observer = new PerformanceObserver(list => {
      if (list.getEntries().some(entry => /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(new URL(entry.name).pathname + new URL(entry.name).search))) schedule();
    });
    observer.observe({ type: 'resource', buffered: true });
  }
  [0, 1500, 4000, 8000].forEach(delay => setTimeout(check, delay));
})();